import { createContext, useContext, useState, useEffect, useCallback } from "react";
import fr from "./fr.json";
import nl from "./nl.json";
import en from "./en.json";

const dictionaries = { fr, nl, en };

export const LANGUAGES = [
  { code: "fr", label: "FR" },
  { code: "nl", label: "NL" },
  { code: "en", label: "EN" },
];

const LanguageContext = createContext(null);

const lookup = (dict, key) =>
  key.split(".").reduce((acc, k) => (acc == null ? undefined : acc[k]), dict);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("e2law-lang");
    return saved && dictionaries[saved] ? saved : "fr";
  });

  useEffect(() => {
    localStorage.setItem("e2law-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (key) => lookup(dictionaries[lang], key) ?? lookup(fr, key) ?? key,
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useTranslation = () => useContext(LanguageContext);
